import { createGlobalStyle } from 'styled-components';

import { cssVarsToString, themeToFlatCssVars } from '../utils/theme-to-css-vars';

/**
 * Global style component that injects theme values as CSS custom properties.
 *
 * This component automatically converts the theme object from ThemeProvider
 * into CSS variables and injects them into the :root selector.
 *
 * The CSS variables are automatically updated whenever the theme changes.
 *
 * @example
 * ```tsx
 * import { ThemeProvider } from 'styled-components';
 * import { Theme } from '@desygner/ui-common-theme-desygner';
 * import { ThemeCssVariables } from '@desygner/ui-common-components';
 *
 * function App() {
 *   return (
 *     <ThemeProvider theme={Theme}>
 *       <ThemeCssVariables />
 *       <YourApp />
 *     </ThemeProvider>
 *   );
 * }
 * ```
 *
 * @example
 * Usage in styled components:
 * ```tsx
 * const StyledButton = styled.button`
 *   // Using theme prop (existing approach)
 *   color: ${({ theme }) => theme.Color.Brand.Primary};
 *
 *   // Using CSS variables (new approach)
 *   color: var(--theme-color-brand-primary);
 *   padding: calc(var(--theme-spacing-size-medium) * 1px);
 * `;
 * ```
 */
export const ThemeCssVariables = createGlobalStyle`
  :root {
${({ theme }) => {
  // Type assertion is safe here as we're converting the theme object to CSS variables
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cssVars = themeToFlatCssVars(theme as any);

  return cssVarsToString(cssVars);
}}
  }
`;
